import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/variables.css";
import "./assets/css/custom.scss";
import "./assets/css/style.scss";

import { QueryClientProvider } from "react-query";
import { AnimatePresence } from "framer-motion";
import { queryClient } from "./config";
import { router } from "./routes";
import { Toaster } from "react-hot-toast";
import { ModalContextProvider } from "./contexts/ModalContext";
import DisableDevtool from 'disable-devtool';


function App() {



  async function checkVersionAndReloadIfNeeded() {
    try {
      const response = await fetch('/meta.json', { cache: 'no-cache' });
      const data = await response.json();
      const currentVersion = data.version;
      let localVersion = localStorage.getItem('app_version');
      if (!localVersion) {
        localStorage.setItem('app_version', currentVersion);
        localVersion = currentVersion;
      }
      if (localVersion && localVersion !== currentVersion) {
        localStorage.setItem('app_version', currentVersion);
        window.location.reload(true);
      }
    }
    catch (err) {
      console.log("Error fetching version:", err);
    }
  }

  useEffect(() => {

    checkVersionAndReloadIfNeeded();
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkVersionAndReloadIfNeeded();
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    // Cleanup
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };


  }, []);

  return (
    <AnimatePresence>
      <ModalContextProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <Toaster position="top-center" />
        </QueryClientProvider>
      </ModalContextProvider>
    </AnimatePresence>
  );
}
export default App;